/* WERK 23 (12 okt 2026): configurator op productpagina's.
   1) Producten met een vaste kleur (metaveld custom.vaste_kleur, data-vk="1"): de configurator opent in die kleur.
      wave-cfg-extra.js zet per model een vaste basiskleur (bv. SPHERE 2176 = Wit RAL 9016); dat mag niet bij een kleurartikel
      zoals 2176.605 Champagne Gold. Dit script laadt eerder (header) en markeert de basiskleur als 'al ingesteld'.
   2) Deeplink naar een kleur naar keuze, bijv. ?ral=9005&afwerking=mat (vanuit de homepage-hero). ?kleur=... werkt al in wave-configurator.js. */
(function () {
  function $$(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function keepFixed() {
    var r = document.querySelector('[data-wvc]');
    if (!r || r.dataset.vk !== '1') return;
    var i = r.querySelector('input[name="wvc-color"][value=""]');
    if (i) i.dataset.baseSet = '1';
  }
  keepFixed();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', keepFixed);

  var q; try { q = new URLSearchParams(location.search); } catch (e) { return; }
  var ral = (q.get('ral') || '').replace(/[^0-9]/g, ''), af = (q.get('afwerking') || '').toLowerCase();
  if (!ral && !af) return;
  function go(n) {
    var r = document.querySelector('[data-wvc]');
    if (!r || !r.dataset.wvcInit || !r.querySelector('.wvs-chip, input[name="wvc-custom-1"]')) { if (n < 60) setTimeout(function () { go(n + 1); }, 150); return; }
    if (ral) {
      var one = $$(r, 'input[name="wvc-color"]').filter(function (i) { return /^1\s+/.test(i.dataset.label || '') && !i.disabled; })[0];
      if (one && !one.checked) { one.checked = true; one.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    setTimeout(function () {
      if (ral) {
        var chip = $$(r, '.wvs-chip').filter(function (b) { return (b.dataset.v || '').indexOf('RAL ' + ral) > -1; })[0];
        if (chip) chip.click();
        else {
          var inp = r.querySelector('input[name="wvc-custom-1"]');
          if (inp) { inp.value = 'RAL ' + ral; inp.dispatchEvent(new Event('input', { bubbles: true })); inp.dispatchEvent(new Event('change', { bubbles: true })); }
        }
      }
      if (af) {
        var f = $$(r, 'input[name="wvs-finish"]').filter(function (x) { return (x.dataset.f || '').toLowerCase() === af; })[0];
        if (f && !f.checked) f.click();
      }
    }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { go(0); }); else go(0);
})();
